import { observer } from "mobx-react";
import React from "react";
import { Modal } from "@mantine/core";
import PaidNotificationDesign from "./helpers/PaidSuccessfulNotificationDesign";
import { MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS } from "../../../helpers/constants";
import { BOB_MODALS } from "../../helpers/constants";
import { Bob } from "../../stores/Bob";
import SelectBob from "../details/selectBob";
import { CustomModalTitle } from "../details/customModalTitle";
import { IconArrowsLeftRight } from "@tabler/icons-react";

const SelectBobModal = observer(({ bob }: { bob: Bob }) => {
  return (
    <Modal
      opened={bob.openModal === BOB_MODALS.SELECT_BOB}
      onClose={() => bob.setOpenModal(null)}
      size={MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS}
      title={
        <CustomModalTitle text="Switch Vault" icon={<IconArrowsLeftRight />} />
      }
    >
      <SelectBob bobsWorkspace={bob.workspace} />
    </Modal>
  );
});

export default SelectBobModal;
